import { useTranslation } from 'react-i18next'

import { Page } from '../../../Page'
import { PageEmptyState } from '../../../PageEmptyState'

import {
  EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_ACTION_NAME,
  QA_NAME_EMAIL_PROFILE_UNAVAILABLE,
} from './EmailProfileUnavailable.constants'
import { EmailProfileUnavailableNavigation } from './EmailProfileUnavailableNavigation'

import EmailIcon from '../../../../icons/email.svg'

function EmailProfileUnavailable({ navigation }) {
  const { t } = useTranslation()

  return (
    <Page qaName={QA_NAME_EMAIL_PROFILE_UNAVAILABLE}>
      <PageEmptyState
        EntityIcon={EmailIcon}
        actions={[
          {
            Component: EmailProfileUnavailableNavigation,
            name: EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_ACTION_NAME,
            navigation,
          },
        ]}
        text={t('EmailProfile.NoLongerAvailableKey')}
      />
    </Page>
  )
}

export default EmailProfileUnavailable
